
const navigation = {
  home: 'Home',
  sugar: 'Zucchero',
  coffee: 'Caffè',
  logistics: 'Logistica',
  news: 'Notizie',
  contact: 'Contatto'
};

const hero = {
  title: 'Esportazioni di Materie Prime',
  subtitle: 'Zucchero e Caffè dal Brasile al Mondo',
  description: 'Il Brasile è leader mondiale nella produzione ed esportazione di zucchero e caffè. Questo sito presenta una panoramica completa di questi prodotti, i loro mercati, la logistica di esportazione e molto altro.',
  exploreSugar: 'Esplora Zucchero',
  discoverCoffee: 'Scopri Caffè'
};

const features = {
  title: 'Esplora le Nostre Sezioni',
  description: 'Scopri informazioni dettagliate sui processi, mercati e logistica delle principali materie prime brasiliane',
  sugar: {
    title: 'Conosci il processo di esportazione dello zucchero',
    description: 'Dal campo al porto: comprendi come lo zucchero brasiliano raggiunge i mercati internazionali'
  },
  coffee: {
    title: 'Scopri i percorsi del caffè brasiliano',
    description: 'Tradizione e qualità che rendono il Brasile il maggiore esportatore mondiale di caffè'
  },
  logistics: {
    title: 'Comprendi la logistica e le navi da carico',
    description: 'L\'infrastruttura portuale e di trasporto che rende possibili le esportazioni'
  },
  learnMore: 'Scopri di Più'
};

const stats = {
  title: 'Il Brasile in Numeri',
  description: 'Dati che dimostrano l\'importanza del Brasile nel mercato mondiale delle materie prime',
  sugarExport: 'Dello zucchero prodotto viene esportato',
  coffeeWorld: 'Del caffè mondiale proviene dal Brasile',
  mainPorts: 'Principali porti esportatori',
  countries: 'Paesi di destinazione'
};

const cta = {
  title: 'Rimani Aggiornato',
  description: 'Segui le ultime tendenze del mercato delle materie prime e le novità del settore',
  seeNews: 'Vedi Notizie',
  contact: 'Mettiti in Contatto'
};

// Sugar page translations
const sugar = {
  hero: {
    title: 'Zucchero Brasiliano',
    subtitle: 'Dal Campo al Porto'
  },
  types: {
    title: 'Tipi di Zucchero Esportato',
    vhp: {
      name: 'VHP (Very High Polarization)',
      description: 'Zucchero grezzo ad alta polarizzazione, ideale per la raffinazione'
    },
    refined: {
      name: 'Raffinato',
      description: 'Zucchero bianco raffinato, pronto per il consumo'
    },
    crystal: {
      name: 'Cristallo',
      description: 'Zucchero cristallizzato, più comune nel mercato interno'
    }
  },
  regions: {
    title: 'Principali Regioni Produttrici',
    sp: {
      name: 'São Paulo',
      production: '55%',
      description: 'Maggiore regione produttrice del paese'
    },
    mg: {
      name: 'Minas Gerais',
      production: '12%',
      description: 'Seconda maggiore regione produttrice'
    },
    go: {
      name: 'Goiás',
      production: '10%',
      description: 'Importante regione del Centro-Ovest'
    }
  },
  process: {
    title: 'Processo di Esportazione',
    step1: {
      title: 'Raccolta della Canna da Zucchero',
      description: 'Raccolta meccanizzata o manuale della canna'
    },
    step2: {
      title: 'Lavorazione negli Zuccherifici',
      description: 'Macinazione ed estrazione del succo di canna'
    },
    step3: {
      title: 'Stoccaggio e Trasporto',
      description: 'Stoccaggio in silos e trasporto stradale'
    },
    step4: {
      title: 'Imbarco nei Porti',
      description: 'Caricamento su navi portarinfuse'
    }
  },
  market: {
    title: 'Mercato Internazionale',
    destinations: 'Principali Destinazioni',
    factors: {
      title: 'Fattori che Influenzano i Prezzi',
      climate: {
        title: 'Condizioni Climatiche:',
        description: 'Siccità o piogge eccessive influenzano la produzione'
      },
      oil: {
        title: 'Prezzo del Petrolio:',
        description: 'Influenza la produzione di etanolo come alternativa'
      },
      demand: {
        title: 'Domanda Mondiale:',
        description: 'Crescita demografica e cambiamenti nel consumo'
      },
      exchange: {
        title: 'Tasso di Cambio:',
        description: 'Variazione del dollaro impatta la competitività'
      }
    }
  },
  curiosities: {
    title: 'Curiosità dello Zucchero Brasiliano',
    exported: 'Della produzione brasiliana viene esportata',
    worldShare: 'Dello zucchero mondiale proviene dal Brasile',
    mills: 'Zuccherifici operativi nel paese',
    hectares: 'Ettari di canna piantati',
    worldRank: 'Posto mondiale nella produzione',
    countries: 'Paesi importano il nostro zucchero'
  }
};

// Coffee page translations
const coffee = {
  hero: {
    title: 'Caffè del Brasile',
    subtitle: 'Tradizione e Qualità Mondiale'
  },
  history: {
    title: 'Storia e Importanza Economica',
    worldProduction: 'Produzione Mondiale',
    jobs: 'Posti di Lavoro Generati',
    exports: 'Esportazioni Annuali',
    importers: 'Paesi Importatori'
  },
  types: {
    title: 'Tipi di Caffè Esportati',
    arabica: {
      name: 'Arabica',
      percentage: '75%',
      description: 'Caffè di alta qualità, sapore delicato e aromatico',
      regions: 'Minas Gerais, São Paulo, Espírito Santo'
    },
    robusta: {
      name: 'Robusta (Conilon)',
      percentage: '25%',
      description: 'Caffè più resistente, sapore forte e maggiore contenuto di caffeina',
      regions: 'Espírito Santo, Rondônia, Bahia'
    }
  },
  states: {
    title: 'Stati Produttori',
    mg: {
      name: 'Minas Gerais',
      production: '54%',
      specialty: 'Arabica di montagna'
    },
    es: {
      name: 'Espírito Santo',
      production: '23%',
      specialty: 'Conilon e Arabica'
    },
    sp: {
      name: 'São Paulo',
      production: '9%',
      specialty: 'Arabica tradizionale'
    },
    ba: {
      name: 'Bahia',
      production: '8%',
      specialty: 'Conilon e caffè speciali'
    }
  },
  process: {
    title: 'Processo di Esportazione',
    step1: {
      title: 'Raccolta',
      description: 'Manuale (derriça) o meccanica'
    },
    step2: {
      title: 'Essiccazione',
      description: 'Naturale sui terrazzi o artificiale'
    },
    step3: {
      title: 'Lavorazione',
      description: 'Sgusciatura e classificazione'
    },
    step4: {
      title: 'Stoccaggio',
      description: 'In sacchi o container'
    },
    step5: {
      title: 'Esportazione',
      description: 'Imbarco nei porti'
    }
  },
  market: {
    title: 'Destinazioni e Consumo Globale',
    destinations: 'Principali Destinazioni',
    factors: {
      title: 'Fattori di Mercato',
      quotes: {
        title: 'Quotazioni Internazionali:',
        description: 'Borse di New York e Londra determinano i prezzi'
      },
      climate: {
        title: 'Condizioni Climatiche:',
        description: 'Gelate e siccità influenzano significativamente i prezzi'
      },
      quality: {
        title: 'Qualità:',
        description: 'Caffè speciali raggiungono prezzi premium'
      },
      logistics: {
        title: 'Logistica:',
        description: 'Costi di trasporto influenzano la competitività'
      }
    }
  },
  trends: {
    title: 'Tendenze del Mercato',
    specialty: {
      title: 'Caffè Speciali',
      description: 'Crescita nella domanda di caffè di origine unica e metodi speciali di preparazione'
    },
    certifications: {
      title: 'Certificazioni',
      description: 'Certificazioni biologiche, Fair Trade e Rainforest Alliance'
    },
    sustainability: {
      title: 'Sostenibilità',
      description: 'Pratiche ambientalmente responsabili e socialmente giuste'
    }
  }
};

// Logistics page translations
const logistics = {
  hero: {
    title: 'Logistica e Trasporti',
    subtitle: 'L\'Infrastruttura Dietro le Esportazioni'
  },
  ships: {
    title: 'Tipi di Navi da Carico',
    bulk: {
      name: 'Portarinfuse (Bulk Carriers)',
      description: 'Navi specializzate nel trasporto di prodotti sfusi come lo zucchero',
      capacity: '60.000 - 200.000 tonnellate'
    },
    containers: {
      name: 'Container Secchi',
      description: 'Trasporto di caffè in sacchi e prodotti imballati',
      capacity: '1.000 - 20.000 TEU'
    },
    refrigerated: {
      name: 'Container Refrigerati',
      description: 'Per prodotti che necessitano controllo della temperatura',
      capacity: '200 - 2.000 TEU'
    }
  },
  ports: {
    title: 'Principali Porti Esportatori',
    santos: {
      name: 'Porto di Santos (SP)',
      description: 'Maggiore porto dell\'America Latina',
      products: 'Zucchero, Caffè, Soia',
      capacity: '4,8 milioni TEU/anno'
    },
    paranagua: {
      name: 'Porto di Paranaguá (PR)',
      description: 'Principale corridoio di esportazione del Sud',
      products: 'Zucchero, Soia, Mais',
      capacity: '1,2 milioni TEU/anno'
    },
    vitoria: {
      name: 'Porto di Vitória (ES)',
      description: 'Importante per minerali e caffè',
      products: 'Caffè, Zucchero, Minerali',
      capacity: '800 mila TEU/anno'
    },
    itaqui: {
      name: 'Porto di Itaqui (MA)',
      description: 'Gateway del Nordest',
      products: 'Zucchero, Soia, Mais',
      capacity: '600 mila TEU/anno'
    }
  },
  storage: {
    title: 'Magazzini e Depositi',
    silos: {
      name: 'Silos per Rinfuse',
      description: 'Stoccaggio verticale per zucchero sfuso',
      capacity: '10.000 - 100.000 tonnellate'
    },
    warehouses: {
      name: 'Depositi Doganali',
      description: 'Magazzini per prodotti in attesa di esportazione',
      capacity: '5.000 - 50.000 tonnellate'
    },
    refrigerated: {
      name: 'Magazzini Refrigerati',
      description: 'Conservazione di prodotti sensibili alla temperatura',
      capacity: '1.000 - 20.000 tonnellate'
    }
  },
  transport: {
    title: 'Trasporti Interni',
    modes: 'Modi di Trasporto',
    road: {
      name: 'Stradale',
      percentage: '70%',
      description: 'Modalità principale per trasporti interni'
    },
    rail: {
      name: 'Ferroviario',
      percentage: '25%',
      description: 'Uso crescente in alcune regioni'
    },
    waterway: {
      name: 'Fluviale',
      percentage: '5%',
      description: 'Utilizzato in regioni specifiche'
    },
    characteristics: {
      title: 'Caratteristiche del Trasporto',
      distances: {
        title: 'Distanze Medie',
        farm: 'Fattoria → Magazzino: 50-200 km',
        warehouse: 'Magazzino → Porto: 200-800 km',
        time: 'Tempo medio: 2-5 giorni'
      },
      costs: {
        title: 'Costi Logistici',
        percent: 'Rappresentano 15-25% del prezzo finale',
        fuel: 'Carburante: componente maggiore',
        tolls: 'Pedaggi e tasse portuali'
      },
      seasonality: {
        title: 'Stagionalità',
        peak: 'Picco durante il raccolto (mag-set)',
        demand: 'Maggiore domanda di trasporto',
        increase: 'Aumento dei noli'
      }
    }
  },
  challenges: {
    title: 'Sfide e Opportunità',
    infrastructure: {
      title: 'Infrastruttura Portuale',
      description: 'Necessità di modernizzazione e ampliamento della capacità'
    },
    costs: {
      title: 'Costi Logistici',
      description: 'Riduzione dei costi di trasporto e stoccaggio'
    },
    sustainability: {
      title: 'Sostenibilità',
      description: 'Implementazione di pratiche ambientalmente responsabili'
    },
    digitalization: {
      title: 'Digitalizzazione',
      description: 'Automazione e controllo digitale dei processi'
    }
  },
  numbers: {
    title: 'Numeri della Logistica',
    tonnage: 'Tonnellate movimentate/anno',
    ports: 'Porti organizzati',
    terminals: 'Terminali privati',
    gdp: 'Costo logistico del PIL'
  }
};

// News page translations
const news = {
  hero: {
    title: 'Notizie e Tendenze',
    subtitle: 'Cosa Sta Succedendo nel Mercato delle Esportazioni?'
  },
  market: {
    title: 'Quotazioni in Tempo Reale'
  },
  tabs: {
    recent: 'Notizie Recenti',
    analysis: 'Analisi',
    forecasts: 'Previsioni'
  },
  analysis: {
    title: 'Analisi di Mercato',
    positive: {
      title: 'Fattori Positivi',
      climate: 'Clima favorevole per prossimo raccolto',
      demand: 'Domanda internazionale crescente',
      infrastructure: 'Miglioramenti nell\'infrastruttura logistica'
    },
    challenges: {
      title: 'Sfide',
      exchange: 'Volatilità del tasso di cambio',
      competition: 'Competizione internazionale',
      costs: 'Costi logistici elevati'
    }
  },
  newsletter: {
    title: 'Rimani Informato',
    description: 'Ricevi aggiornamenti settimanali sul mercato delle materie prime direttamente nella tua email',
    placeholder: 'La tua email',
    subscribe: 'Iscriviti'
  }
};

// Contact page translations
const contact = {
  hero: {
    title: 'Sul Progetto',
    subtitle: 'Conosci il nostro team e mettiti in contatto con noi'
  },
  about: {
    title: 'Chi Siamo'
  },
  objectives: {
    title: 'I Nostri Obiettivi',
    educational: {
      title: 'Educativo',
      description: 'Educare sui processi di produzione ed esportazione delle principali materie prime brasiliane'
    },
    informative: {
      title: 'Informativo',
      description: 'Fornire dati aggiornati su mercati, prezzi e tendenze del settore'
    },
    connective: {
      title: 'Connettivo',
      description: 'Connettere diversi pubblici interessati all\'agribusiness brasiliano'
    }
  },
  team: {
    title: 'Il Nostro Team'
  },
  sources: {
    title: 'Fonti dei Dati',
    description: 'Utilizziamo esclusivamente dati ufficiali di istituzioni riconosciute per garantire precisione e affidabilità delle informazioni presentate.'
  },
  form: {
    title: 'Mettiti in Contatto',
    subtitle: 'Hai domande, suggerimenti o vorresti contribuire? Parlaci!',
    name: 'Nome Completo',
    email: 'Email',
    subject: 'Oggetto',
    message: 'Messaggio',
    send: 'Invia Messaggio',
    sending: 'Invio...',
    success: 'Messaggio inviato con successo! Ti contatteremo presto.',
    error: 'Errore nell\'invio del messaggio. Riprova.',
    selectSubject: 'Seleziona un oggetto',
    subjects: {
      doubt: 'Domanda sui dati',
      suggestion: 'Suggerimento di miglioramento',
      contribution: 'Contributo con dati',
      partnership: 'Proposta di partnership',
      press: 'Stampa',
      other: 'Altro'
    },
    placeholder: {
      name: 'Il tuo nome completo',
      email: 'tua@email.com',
      message: 'Descrivi il tuo messaggio (massimo 500 caratteri)'
    },
    charRemaining: 'caratteri rimanenti'
  },
  social: {
    title: 'Seguici',
    description: 'Seguici sui social media per ricevere gli ultimi aggiornamenti sul mercato delle materie prime'
  }
};

export default {
  navigation,
  hero,
  features,
  stats,
  cta,
  sugar,
  coffee,
  logistics,
  news,
  contact
};
